import { Link } from '@tanstack/react-router'

import type { auditLogGridContract, DataGridColumnRenderers } from '@/modules/data-grid'
import { RelativeTime } from '@/ui/relative-time'
import { SubjectChip } from '@/ui/subject-chip'

export const auditLogRenderers: DataGridColumnRenderers<typeof auditLogGridContract> = {
  timestamp: {
    cell: ({ value }) => value ? <RelativeTime iso={value} /> : '—',
  },
  entity: {
    cell: ({ value, row }) => value && row.values.entityId ? (
      <Link
        to="/$entityId/dashboard"
        params={{ entityId: row.values.entityId }}
        className="text-primary underline-offset-4 hover:underline"
      >
        {value}
      </Link>
    ) : '—',
  },
  actor: {
    cell: ({ value, row }) => {
      const labels = [
        row.values.origin === 'API' || row.values.origin === 'MCP'
          ? `via ${row.values.origin}`
          : null,
        row.values.initiatedBy ? `via ${row.values.initiatedBy}` : null,
      ].filter((label): label is string => Boolean(label))

      return (
        <span className="inline-flex items-center gap-2">
          {value}
          {labels.map((label) => <SubjectChip key={label} label={label} />)}
        </span>
      )
    },
  },
}
